import { Directive, input } from '@angular/core';

import {
  BLAZE_TARGET_CLASS,
  ELEMENT_ID_ATTR,
  ELEMENT_REFERENCED_SLOT_ID_ATTR,
  SlotId,
} from '@blaze-runtime/engine-domain';

@Directive({
  selector: '[blazeReferenceDragHitbox]',
  host: {
    [`[class.${BLAZE_TARGET_CLASS}]`]: 'blazeReferenceDragHitbox()',
    [`[attr.${ELEMENT_ID_ATTR}]`]: 'blazeReferenceDragHitbox() && elementId()',
    [`[attr.${ELEMENT_REFERENCED_SLOT_ID_ATTR}]`]: 'blazeReferenceDragHitbox() && targetSlotId()',
  },
  standalone: false,
})
export class ReferenceDragHitboxDirective {
  readonly blazeReferenceDragHitbox = input<boolean>(true);
  readonly elementId = input.required<string>();
  readonly targetSlotId = input.required<SlotId>();
}
